import { AuthGuard, AuthInterceptor, TransactionGuard } from '@sigepe/ngx-sigepe-seguranca';

import { ConfigEnvironment } from './environment.base';

const HOST_SIGEPE_AD_API = 'https://prod-sigepe-api.estaleiro.serpro.gov.br/avaliacao-desempenho-v2';
const API_GATEWAY = 'https://prod-sigepe-api.estaleiro.serpro.gov.br';
const HOST_SIGEPE_EORG = 'https://prod-sigepe-api.estaleiro.serpro.gov.br/eorg';
const SECURITY_HOSTS = [API_GATEWAY];

//Autoriza
const HOST_LOGIN_UNICO = 'https://sso.acesso.gov.br';
const HOST_JSKS = 'http://localhost:8080';
const HOST_API_SIGEPE = 'https://prod-sigepe-api.estaleiro.serpro.gov.br/seguranca';
const CLIENT_ID = 'sigepe.gov.br';
const COOKIE_DOMAIN = '.sigepe.gov.br';

const config = new ConfigEnvironment(
	HOST_SIGEPE_AD_API,
	HOST_SIGEPE_EORG,
	SECURITY_HOSTS,
	HOST_LOGIN_UNICO,
	HOST_JSKS,
	HOST_API_SIGEPE,
	CLIENT_ID,
	COOKIE_DOMAIN
);

export const environment = {
	PROVIDER_AUTH: AuthInterceptor,
	GUARDS_AND_TRANSACTION: [AuthGuard, TransactionGuard],
	production: false,
	footerUrl: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/template/rodapeSigepe/text',
	menuUrl: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/menu-sigepe',
	mensageriaUrl: 'https://ca-mensageiria.sigepe.gov.br/sigepe-ca-mensageiria-web/private/leitor.jsf',
	manualUrl: 'https://bgp.sigepe.gov.br/sigepe-bgp-web-intranet/pages/manual/consultar.jsf',
	sistemaOrigem: 'AVALIACAO_DESEMPENHO',
	menuAddFromRouter: true,
	menuIgnoreRouterGuard: false,
	avaliacaoFuncionalidadeConfiguration: {
		urlApi: 'https://prod-sigepe-api.estaleiro.serpro.gov.br/pesquisa-avaliacao/avaliacao-servico/v1/'
	},
	analyticsSettings: {
		trackingCode: 'G-1QNYP5VCR3'
	},
	chatbotConfiguration: {
		urlApi: 'https://serprobots.estaleiro.serpro.gov.br/web/bot-resolve-sipec-p/index.html',
		disable: false
	},
	...config.getEnvironment()
};
